
const editors = {
    textfield : (cell, onRendered, success, cancel, editorParams) => {
        var cellValue = cell.getValue(),
          input = document.createElement("input");

        input.setAttribute("type", editorParams.search ? "search" : "text");
        input.style.width = "100%";
        input.style.height = "100%";
        input.style.borderRadius = "2";
        if (
          editorParams.elementAttributes &&
          typeof editorParams.elementAttributes == "object"
        ) {
          for (let key in editorParams.elementAttributes) {
            if (key.charAt(0) == "+") {
              key = key.slice(1);
              input.setAttribute(
                key,
                input.getAttribute(key) +
                  editorParams.elementAttributes["+" + key]
              );
            } else {
              input.setAttribute(key, editorParams.elementAttributes[key]);
            }
          }
        }

        input.value = typeof cellValue !== "undefined" ? cellValue : "";

        onRendered(function () {
          input.focus();
          input.select();
          $(input).css({'height':'100%','box-sizing':'border-box'});
        });

        function onChange(e) {
          if (
            ((cellValue === null || typeof cellValue === "undefined") &&
              input.value !== "") ||
            input.value != cellValue
          ) {
            if (success(input.value)) {
              cellValue = input.value; //persist value if successfully validated in case editor is used as header filter
            }
          } else {
            cancel();
          }
        }

        //submit new value on blur or change
        input.addEventListener("change", onChange);
        input.addEventListener("blur", onChange);

        //submit new value on enter
        input.addEventListener("keydown", function (e) {
          switch (e.keyCode) {
            case 13:
              onChange(e);
              break;

            case 27:
              cancel();
              break;

            case 37: //left
              if(e.ctrlKey){
                 var row = cell.getRow(); 
                 var cells = row.getCells();
                 var value = $(this).val();
                
                 $.each(cells, function(){
                     var columnDef = this.getColumn().getDefinition();
                     if (typeof(columnDef.editable) == 'function' || columnDef.editable == null || columnDef.editable) {
                        if (!columnDef.editable(this)){
                            return;
                        }
                         if (columnDef.editor == 'textfield') {
                             this.setValue(value);
                         }
                     }
                 }) 
               }
               break;
            case 38: //up
             if(e.ctrlKey){
                 var column = cell.getColumn(); 
                 var value = $(this).val();
                 var columnDef = column.getDefinition();
                 var row =  cell.getRow();
                 var newCell = {};
                 var prevRow = row.getPrevRow();    
                 
                 while (prevRow) {
                    newCell = prevRow.getCell(column);
                    if (typeof(columnDef.editable) == 'function'){
                        if (columnDef.editable(newCell)){
                            newCell.setValue(value);
                        }
                    } else {
                        newCell.setValue(value);
                    }
                     
                    prevRow = newCell.getRow().getPrevRow();    
                 }
               }
               break;
            case 39: //right
             if(e.ctrlKey){
                 var row = cell.getRow(); 
                 var cells = row.getCells();
                 var value = $(this).val();
                 var past = false;
                 $.each(cells, function(){
                     var columnDef = this.getColumn().getDefinition();
                     if (columnDef.field == cell.getColumn().getDefinition().field){
                         past = true;
                         return;
                     }
                     if (!past){
                         return; // don't edit cells to the left;
                     }
                     if (typeof(columnDef.editable) == 'function' || columnDef.editable == null || columnDef.editable) {
                         if (typeof(columnDef.editable) == 'function'){
                            if (!columnDef.editable(this)){
                                return;
                            }
                         }
                         if (columnDef.editor == 'textfield') {
                             this.setValue(value);
                         }
                     }
                 }) 
               }
               break;
            case 40: //down
               if(e.ctrlKey){
                 var column = cell.getColumn(); 
                 var value = $(this).val();
                 var columnDef = column.getDefinition();
                 var row =  cell.getRow();
                 var newCell = {};
                 var nextRow = row.getNextRow();    
                 
                 while (nextRow) {
                    newCell = nextRow.getCell(column);
                    if (typeof(columnDef.editable) == 'function'){
                        if (columnDef.editable(newCell)){
                            newCell.setValue(value);
                        }
                    } else {
                        newCell.setValue(value);
                    }
                     
                    nextRow = newCell.getRow().getNextRow();    
                 }
               }
               break;
          }
        });

        return input;
      }
}

export {editors};
